import get from 'lodash.get';
import * as helpers from './checkoutHelpers';
import * as user from './checkoutUser';
import * as forms from './checkoutForms';
import * as storage from './checkoutStorage';
import * as redirects from './checkoutRedirects';
import * as tracking from './checkoutTracking';

const isWindowEnv = typeof window !== 'undefined';

function getHelpers() {
    return {
        helpers,
        user,
        forms,
        storage,
        redirects,
        tracking,
    };
}

function getStoreName(name = '') {
    return `Checkout${name.charAt(0).toUpperCase()}${name.slice(1)}Store`;
}

function getStore(context, name) {
    try {
        return context.getStore(getStoreName(name));
    } catch (e) {
        return console.warn(`Can't find ${name}, please check your spelling and try again.`);
    }
}

function report(store, prop) {
    console.log(`${prop}:`, store.state[prop]); // eslint-disable-line
}

export function consoleError(error) {
    if (isWindowEnv && !window.checkout) {
        window.checkout = { ...getHelpers() };
    }
    if (get(error, 'stack')) {
        console.log(error, error.stack); // eslint-disable-line
    } else if (get(error, 'responseJSON.message')) {
        console.log(error, error.responseJSON.message); // eslint-disable-line
    } else {
        console.log(error); // eslint-disable-line
    }
}

//this should be replaced by react dev tools
// perhaps have a function that allows you to set value in the store quickly
export function initialDebug(context, environment) {
    // Attach to window for console debugging
    if (!isWindowEnv) {
        return;
    }
    window.checkout = {
        ...getHelpers(),
        environment,
        context,
        getStore: getStore.bind(null, context),
        getProp(storeName, propName) {
            const store = getStore(context, storeName) || null;
            if (store) {
                report(store, propName);
            }
        },
        setProp(storeName, propName, value) {
            const store = getStore(context, storeName) || null;
            if (store) {
                store.state = { ...store.state, [propName]: value };
                report(store, propName);
                store.emitChange();
            }
        },
    };
}
